import React from 'react'
import { AiOutlineCloseCircle, AiOutlineUserDelete } from 'react-icons/ai'
import { BsTrash2 } from 'react-icons/bs'

const DeleteGroupModal = ({
  setShow,
  show,
  handleDelete,
  title = "Delete This Group?",
  description = "Are you sure you want to delete this group? This action is irreversible.",
  deleting = false,
  label = "Group"
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full max-w-[400px] p-4 relative">
        <button
          onClick={() => setShow(false)}
          disabled={deleting}
          className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <AiOutlineCloseCircle className="h-7 w-7 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-yellowcolor/10 rounded-full flex items-center justify-center mb-3">
            <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="5" y="5.5" width="56" height="56" rx="28" fill="#FEECB8" />
              <rect x="5" y="5.5" width="56" height="56" rx="28" stroke="#FFF9E8" stroke-width="10" />
              <path d="M37 27V26.2C37 25.0799 37 24.5198 36.782 24.092C36.5903 23.7157 36.2843 23.4097 35.908 23.218C35.4802 23 34.9201 23 33.8 23H32.2C31.0799 23 30.5198 23 30.092 23.218C29.7157 23.4097 29.4097 23.7157 29.218 24.092C29 24.5198 29 25.0799 29 26.2V27M31 32.5V37.5M35 32.5V37.5M24 27H42M40 27V38.2C40 39.8802 40 40.7202 39.673 41.362C39.3854 41.9265 38.9265 42.3854 38.362 42.673C37.7202 43 36.8802 43 35.2 43H30.8C29.1198 43 28.2798 43 27.638 42.673C27.0735 42.3854 26.6146 41.9265 26.327 41.362C26 40.7202 26 39.8802 26 38.2V27" stroke="#E5B117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

          </div>

          <h2 className="text-xl font-bold mb-2 dark:text-white">
            {title}
          </h2>
          <p className="text-gray-600 text-sm dark:text-gray-400 mb-6">
            {description}
          </p>

          <div className="flex gap-4 w-full">
            <button className="flex-1 h-12 rounded-full border border-gray-400 dark:border-border-darkGray dark:text-white" onClick={() => setShow(false)} disabled={deleting}>
              Cancel
            </button>
            <button className="flex-1 h-12 rounded-full bg-yellowcolor hover:bg-yellowcolor/80 text-black" onClick={handleDelete} disabled={deleting}>
              {deleting ? "Deleting..." : `Delete ${label}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteGroupModal